import { AxiosInstance } from 'axios';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';

import {
  CreateUserRequest,
  CreateUserResponse,
  DeleteUserRequest,
  UserSearchRequest,
  UserSearchResponse,
  SetUserRoleRequest,
  ToggleUserAccessRequest,
  UpdateUserRequest,
  UserMeResponse,
  UserGetByIdRequest,
  UserGetByIdResponse,
} from './UserService.types';

export class UserService implements BaseRequestEndpoints {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getMe() {
    return this.instance.get<UserMeResponse>('/users/me');
  }

  getById({ routeParams }: UserGetByIdRequest) {
    return this.instance.get<UserGetByIdResponse>(`/users/${routeParams.userGuid}`);
  }

  search(request: UserSearchRequest) {
    return this.instance.get<UserSearchResponse>(`/users`, {
      params: request.queryParams,
    });
  }

  create(request: CreateUserRequest) {
    return this.instance.post<CreateUserResponse>('/users', request.body);
  }

  update(request: UpdateUserRequest) {
    return this.instance.put<CreateUserResponse>(
      `/users/${request.routeParams.userId}`,
      request.body,
    );
  }

  toggleUserAccess(request: ToggleUserAccessRequest) {
    return this.instance.put<void>(`/users/${request.routeParams.userId}/access`, request.body);
  }

  setUserRole(request: SetUserRoleRequest) {
    return this.instance.put<boolean>(
      `/users/${request.routeParams.userId}/roles/${request.routeParams.roleId}`,
    );
  }

  delete(request: DeleteUserRequest) {
    return this.instance.delete<boolean>(`/users/${request.routeParams.userId}`);
  }
}
